module.exports = __webpack_public_path__ + "static/neha-645c0d4245193c1af48ae4f737944a79.jpeg";